var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Export',{attrs:{"workflowKey":"spraying"}},[_c('ExportTable',{attrs:{"tableHeaders":_vm.tableHeaders,"tableRows":_vm.tableRows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }